import * as React from 'react'

export const SVG_WhiteCross = () => (
    <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1">
        <defs>
            <path
                d="M10.7173231,9.98448615 L14.8166822,5.88470777 C15.0195959,5.68221335 15.0195959,5.35436524 14.8166822,5.15187082 C14.6146071,4.94937639 14.286759,4.94937639 14.0842645,5.15187082 L9.98448615,9.2516492 L5.88470777,5.15187082 C5.68221335,4.94937639 5.353946,4.94937639 5.15187082,5.15187082 C4.94937639,5.35436524 4.94937639,5.68221335 5.15187082,5.88470777 L9.2516492,9.98448615 L5.15187082,14.0842645 C4.94937639,14.286759 4.94937639,14.6146071 5.15187082,14.8171015 C5.353946,15.0195959 5.68221335,15.0195959 5.88470777,14.8171015 L9.98448615,10.7173231 L14.0842645,14.8171015 C14.286759,15.0195959 14.6146071,15.0195959 14.8166822,14.8171015 C15.0195959,14.6146071 15.0195959,14.286759 14.8166822,14.0842645 L10.7173231,9.98448615 Z"
                id="path-1"
            />
        </defs>
        <g id="Icons/White-cross" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <circle id="Oval" fill="#FFFFFF" cx="12" cy="12" r="11" />
            <g id="Icons/Delete" transform="translate(2.000000, 2.000000)">
                <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                </mask>
                <use id="Fill-1" fill="#4F5B68" fillRule="evenodd" xlinkHref="#path-1" />
            </g>
        </g>
    </svg>
)
